export const ITEM_TAX_DOCUMENT_DROP_DOWN_ITEMS = []